<template>
  <div style="width:100%">
      <v-row no-gutters>
        <v-col cols="12" md="6" class="pr-2">
          <v-autocomplete v-model="formbuscar.buscar" :items="items_busquedas" label="FILTROS"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" class="pr-1" >
          <v-autocomplete v-if="formbuscar.buscar === 'NIVELES'" v-model="formbuscar.nivel" :items="items_niveles" label="NIVELES" item-text="descripcion" item-value="descripcion"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-row>
            <v-col cols="12" md="6">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn block v-bind="attrs" v-on="on" @click="nuevo_pqr"><v-icon>mdi-file-outline</v-icon> </v-btn>
                </template>
                <span>Crear PQR</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" md="6">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="actualizar" block v-bind="attrs" v-on="on"> <v-icon>mdi-refresh</v-icon> </v-btn>
                </template>
                <span>Refrescar</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="formbuscar.buscar === 'AREAS'">
        <v-col cols="12" md="6">
          <v-autocomplete v-model="formbuscar.area" :items="items_areas" label="AREAS" item-text="descripcion" item-value="id"></v-autocomplete>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="formbuscar.buscar === 'AREAS'">
        <v-col cols="12" md="6">
          <v-autocomplete v-model="formbuscar.afiltro" :items="items_abusquedas" label="FILTROS"></v-autocomplete>
        </v-col>
      </v-row>
      <br>
      <bandejegaListado :colores="colores" :session="session" :items_creados="items_creados" :items_escalamientos="items_escalamientos" :items_cerrar="items_cerrar"></bandejegaListado>

  </div>
</template>

<script>
import bandejegaListado from '@/components/bandejas/bandeja_pqrs_listadoComponent.vue'
export default {
  name: 'bandeja_pqrsComponent',
  components: {
    bandejegaListado
  },
  props: ['items_creados', 'formbuscar', 'items_areas', 'items_abusquedas', 'items_busquedas', 'items_niveles', 'items_escalamientos', 'items_cerrar', 'colores', 'session'],
  data: () => ({
  }),
  methods: {
    actualizar () {
      this.$emit('refresh_listado')
    },
    nuevo_pqr () {
      this.$emit('new_inbound')
    }
  }
}
</script>
